import type { SpotifyAuthStatus } from '@hitster/shared';

/**
 * HTTP-Zugriffe auf die Auth-Endpunkte des Servers.
 * Alles same-origin (Dev via Vite-Proxy), damit die Session-Cookies greifen.
 */

export async function fetchAuthStatus(): Promise<SpotifyAuthStatus> {
  const response = await fetch('/api/auth/status', { credentials: 'same-origin' });
  if (!response.ok) {
    return {
      linked: false,
      displayName: null,
      userId: null,
      hasPremium: false,
      productType: null,
      missingScopes: [],
    };
  }
  return (await response.json()) as SpotifyAuthStatus;
}

/**
 * Startet den OAuth-Flow. Voller Seitenwechsel ist hier richtig --
 * Spotify erlaubt den Zustimmungsdialog nicht im iframe.
 */
export function startSpotifyLogin(returnTo: string = window.location.pathname): void {
  const url = new URL('/api/auth/login', window.location.origin);
  url.searchParams.set('returnTo', returnTo);
  window.location.href = url.toString();
}

export async function logoutSpotify(): Promise<void> {
  await fetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin' });
}

export async function refreshSpotifyProfile(): Promise<SpotifyAuthStatus> {
  const response = await fetch('/api/auth/refresh', {
    method: 'POST',
    credentials: 'same-origin',
  });
  if (!response.ok) throw new Error('refresh_failed');
  return (await response.json()) as SpotifyAuthStatus;
}

/**
 * Holt einen kurzlebigen Access-Token fuer das Web Playback SDK.
 * Wird vom SDK selbst erneut aufgerufen, wenn der Token ablaeuft.
 */
export async function fetchPlaybackToken(): Promise<string> {
  const response = await fetch('/api/auth/token', { credentials: 'same-origin' });
  if (!response.ok) throw new Error('token_unavailable');
  const data = (await response.json()) as { accessToken: string };
  return data.accessToken;
}
